// extracted by mini-css-extract-plugin
export default {"root":"Button_root__9Jch0","fullWidth":"Button_fullWidth__ZKkcv","primary":"Button_primary__c9haR","secondary":"Button_secondary__ZUWAd","icon":"Button_icon__cwXIl"};